/**
 * Перечисление прав доступа
 */
export const DIRECTOR = 'DIRECTOR';

export const VIEW_CARD = 'VIEW_CARD';
export const EDIT_CARD = 'EDIT_CARD';
export const DELETE_CARD = 'DELETE_CARD';
export const MODERATE_CARD = 'MODERATE_CARD';
export const REQUEST_EDIT_CARD = 'REQUEST_EDIT_CARD';
export const CREATE_OFFICE = 'CREATE_OFFICE';
export const EDIT_OFFICE = 'EDIT_OFFICE';
export const DELETE_OFFICE = 'DELETE_OFFICE';
export const CREATE_CLUSTER = 'CREATE_CLUSTER';
export const EDIT_CLUSTER = 'EDIT_CLUSTER';
export const DELETE_CLUSTER = 'DELETE_CLUSTER';


export const VIEW_ANALYTIC = 'VIEW_ANALYTIC';
export const VIEW_FUNNEL = 'VIEW_FUNNEL';

export const EDIT_ALL = 'EDIT_ALL';

export const DICT_USER = 'DICT_USER';
export const DICT_PARTNER = 'DICT_PARTNER';
export const DICT_CONTACT = 'DICT_CONTACT';
export const DICT_TAG = 'DICT_TAG';
export const DICT_SOFTWARE_CLASS = 'DICT_SOFTWARE_CLASS';
export const DICT_SOFTWARE_ANALOG = 'DICT_SOFTWARE_ANALOG';
export const DICT_SOURCE = 'DICT_SOURCE';
export const DICT_SOURCE_ADDITION = 'DICT_SOURCE_ADDITION';
export const DICT_IDEA = 'DICT_IDEA';
export const DICT_PROJECT_STATUS = 'DICT_PROJECT_STATUS';
export const DICT_LEADER = 'DICT_LEADER';
export const DICT_INDUSTRY = 'DICT_INDUSTRY';
export const DICT_DOMAIN = 'DICT_DOMAIN';
export const FEEDBACK_LOG = 'FEEDBACK_LOG';


export const DICT_RIGHTS = [
    DICT_USER,
    DICT_PARTNER,
    DICT_CONTACT,
    DICT_TAG,
    DICT_SOFTWARE_CLASS,
    DICT_SOFTWARE_ANALOG,
    DICT_SOURCE,
    DICT_SOURCE_ADDITION,
    DICT_IDEA,
    DICT_PROJECT_STATUS,
    DICT_LEADER,
    DICT_INDUSTRY,
    DICT_DOMAIN,
    FEEDBACK_LOG,
];
